// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-H":"H_power-ocean-collection-H__g9UBj"};